/**
 * Header Layout
 *
 * @file header.js
 */

import $ from "jquery";

const header = (() => {
  const fixedHeader = () => {
    $(window).scroll(function(){
      var sticky = $('.o-header'),
          scroll = $(window).scrollTop();
    
      if (scroll >= 100) sticky.addClass('fixed_header');
      else sticky.removeClass('fixed_header');
    });
  };
  
  const mobileMenu = () => {
    $(".mobile-hamburger-menu").on("click", function(){
      $(this).toggleClass("active");
      $("body").toggleClass("hidden");
      $(".header-right").toggleClass("active");
    });
  };
  

  const fullSearch = () => {
    $("header .search, .mobile-search").on("click", function(){
      $(".full-search").toggleClass("active");
      $("html").toggleClass("hidden");
      setTimeout(() => {
        $(".full-search input").focus();
      }, "500");
    });
    $(".full-search .bg").on("click", function(){
      $(".full-search").removeClass("active");
      $("html").removeClass("hidden");
      setTimeout(() => {
        $(".full-search input").blur();
      }, "500");
    });
  };

  const init = () => {
    fixedHeader();
    mobileMenu();
    fullSearch();
  };

  return {
    init,
  };
})();

export default header;
